import React, { useEffect, useState } from 'react';
import useWindowSize from '../../../../../../Utils/useWindowSize/useWindowSize';
import './CardThirdPage.scss';

type Props = {
    card: CardProps;
    content?: string;
};
export interface CardProps {
    title: string;
    img1: string;
    img2: string;
    text: string;
}

const CardThirdPage = ({ card, content }: Props) => {
    const [hover, setHover] = useState<boolean>(false);

    const i18nextLng = localStorage.getItem('i18nextLng');

    const { width, height } = useWindowSize();

    const [lengthContent, setLengthContent] = useState<number>(185);

    useEffect(() => {
        if (i18nextLng === 'en') {
            if (width > 1080) {
                setLengthContent(200);
            } else if (width >= 768) {
                setLengthContent(165);
            } else if (width > 576) {
                setLengthContent(145);
            } else {
                setLengthContent(140);
            }
        } else {
            if (width > 1080) {
                setLengthContent(200);
            } else if (width >= 768) {
                setLengthContent(120);
            } else if (width > 576) {
                setLengthContent(100);
            } else {
                setLengthContent(80);
            }
        }
    }, [width]);

    return (
        <div className="card-container" onMouseLeave={() => setHover(false)} onMouseOver={() => setHover(true)}>
            <p className="card-title">{card.title}</p>
            <img className="card-img" alt="" style={{ backgroundImage: card.img1 }} src={`${hover ? card.img2 : card.img1}`}></img>
            <p className="card-title-hover">{card.title}</p>
            {content ? (
                <p className={`card-text ${i18nextLng === 'en' ? 'text-en' : 'text-kr'}`}>
                    {content.substring(0, lengthContent)}
                    {width > 1024 && i18nextLng === 'kr' ? '' : '...'}&nbsp;
                </p>
            ) : null}
        </div>
    );
};

export default CardThirdPage;
